export default {
  area: "灵宝市居民养老",
  objectName: "灵宝市居民养老",
  point: { lng: 112.384568, lat: 34.672387 },
  mapAttr: {
    mapType: "BMAP_NORMAL_MAP",
    zoom: 17
  },
  //url
  hostUrl: 'https://lbzhyl.anluoyun.cn',
  apiHttpsUrl: 'https://lbzhyl.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://lbzhyl.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://lbzhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://lbzhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiRequestUrlOrgan: 'https://lbzhylso.anluoyun.cn/prod-api/So/',
  logo: require("../../src/assets/logo.png")
}